import { combineReducers } from 'redux'
import auth from './reducers/auth'
import dataService from './reducers/data-service'

export default combineReducers({
    auth,
    dataService,
})
